import { render, staticRenderFns } from "./adminClient.vue?vue&type=template&id=3a9f0eca&scoped=true&"
import script from "./adminClient.vue?vue&type=script&lang=js&"
export * from "./adminClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9f0eca",
  null
  
)

export default component.exports